<template>
  <div class="whiteboard-toolbar d-flex-row flex-align-center">
    <button class="btn" :class="{active: mode==='text'}" @click="$emit('set-mode','text')" title="Texto"><i class="fa fa-font"></i></button>
    <button class="btn" :class="{active: mode==='draw'}" @click="$emit('set-mode','draw')" title="Desenho livre"><i class="fa fa-pencil"></i></button>
    <button class="btn" :class="{active: mode==='eraser'}" @click="$emit('set-mode','eraser')" title="Borracha"><i class="fa fa-eraser"></i></button>
    <button class="btn" :class="{active: mode==='line'}" @click="$emit('set-mode','line')" title="Linha reta"><i class="fa fa-minus"></i></button>
    <button class="btn" :class="{active: mode==='rect'}" @click="$emit('set-mode','rect')" title="Retângulo"><i class="fa fa-square-o"></i></button>
    <button class="btn" :class="{active: mode==='circle'}" @click="$emit('set-mode','circle')" title="Círculo"><i class="fa fa-circle-o"></i></button>
    <button class="btn" :class="{active: mode==='polygon'}" @click="$emit('set-mode','polygon')" title="Polígono"><i class="fa fa-star-o"></i></button>

    <select v-if="mode === 'polygon'" class="form-select d-inline-block w-auto me-2" @change="$emit('update-sides', Number($event.target.value))" style="padding: 4px; margin-right: 6px;">
      <option value="3" selected>Triângulo</option>
      <option value="4">Losango</option>
      <option value="5">Pentágono</option>
      <option value="6">Hexágono</option>
      <option value="8">Octógono</option>
    </select>

    <button class="btn" :class="{active: mode==='arrow'}" @click="$emit('set-mode','arrow')" title="Seta"><i class="fa fa-long-arrow-right"></i></button>

    <div class="color-dropdown-wrapper" style="position: relative; display: inline-block; margin-left: 6px;">
      <button class="btn" @click="showColorMenu = !showColorMenu" title="Paleta de cores">
        <i class="fa fa-paint-brush"></i> <i class="fa fa-caret-down" style="font-size: 10px; margin-left: 2px;"></i>
      </button>

      <div v-if="showColorMenu" class="color-dropdown-menu" style="position: absolute; top: 100%; left: 0; background: #ffffff; border: 1px solid #ccc; border-radius: 4px; padding: 10px; z-index: 1050; box-shadow: 0 2px 10px rgba(0,0,0,0.15); display: flex; flex-direction: column; gap: 8px; min-width: 140px;">
        <label class="d-flex-row flex-align-center" style="gap: 8px; font-size: 12px; margin: 0; justify-content: space-between; cursor: pointer;">
          <span style="white-space: nowrap;">Contorno:</span>
          <input type="color" :value="strokeColor" @input="$emit('update-stroke-color', $event.target.value)" style="width: 30px; height: 25px; padding: 0; border: 1px solid #ccc; cursor: pointer;" title="Cor da linha/texto" />
        </label>
        <div class="d-flex-row flex-align-center" style="gap: 8px; font-size: 12px; margin: 0; justify-content: space-between;">
          <span style="white-space: nowrap;">Preenchimento:</span>
          <div class="d-flex-row flex-align-center" style="gap: 4px;">
            <button
              type="button"
              class="btn btn-xs"
              :class="fillColor === 'transparent' ? 'btn-primary' : 'btn-default'"
              @click="$emit('update-fill-color', 'transparent')"
              style="padding: 2px 6px; font-size: 10px;"
              title="Sem preenchimento"
            >
              <i class="fa fa-ban"></i>
            </button>
            <input
              type="color"
              :value="fillColor === 'transparent' ? '#ffffff' : fillColor"
              @input="$emit('update-fill-color', $event.target.value)"
              style="width: 30px; height: 25px; padding: 0; border: 1px solid #ccc; cursor: pointer;"
              :style="{ opacity: fillColor === 'transparent' ? 0.4 : 1 }"
              title="Cor interna das formas"
            />
          </div>
        </div>
        <label class="d-flex-row flex-align-center" style="gap: 8px; font-size: 12px; margin: 0; justify-content: space-between; cursor: pointer;">
          <span style="white-space: nowrap;">Fundo:</span>
          <input type="color" :value="bgColor" @input="$emit('update-bg-color', $event.target.value)" style="width: 30px; height: 25px; padding: 0; border: 1px solid #ccc; cursor: pointer;" title="Cor de fundo da tela" />
        </label>
      </div>
    </div>

    <button class="btn" @click="$emit('undo')" title="Desfazer"><i class="fa fa-undo"></i></button>
    <button class="btn" @click="$emit('redo')" title="Refazer"><i class="fa fa-repeat"></i></button>
    <button class="btn btn-danger" @click="$emit('clear')" title="Limpar"><i class="fa fa-trash"></i></button>
  </div>
</template>

<script>
export default {
  name: "WhiteboardToolbar",
  props: {
    mode: { type: String, default: 'select' },
    strokeColor: { type: String, default: '#000000' },
    fillColor: { type: String, default: 'transparent' },
    bgColor: { type: String, default: '#ffffff' }
  },
  data() {
    return {
      showColorMenu: false
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (file) this.$emit('image-file', file);
      e.target.value = '';
    }
  }
}
</script>

<style scoped>
.whiteboard-toolbar .btn { margin-right: 6px; }
.whiteboard-toolbar .btn.active { background: #96a4bf; }
</style>
